export const BASE_API = 'https://us-central1-app-d8a1c.cloudfunctions.net/api';

export const PROJECT_NAME = '919 Admin';

export const GET_USER_DATA = '/user';

export const GET_USER_LIST = '/getUsersList';

export const GET_COMPANIES_IN_MODERATED = '/getCompaniesInModerated';

export const COMPANIES = '/companies';

export const ACCEPT_COMPANY = '/acceptCompany';

export const BAN_COMPANY = '/banCompany';

export const GET_CASTINGS_IN_MODERATED = '/getCastingsInModerated';

export const ACCEPT_CASTING = '/acceptCasting';

export const DECLINE_CASTING = '/declineCasting';

export const GET_CASTINGS = '/getCastings';

export const CATEGORIES = '/categories';

export const GET_MODERATED_INFO = '/getModeratedInfo';

export const GET_APPLICANT_CASTINGS = '/getApplicantCastings';

export const GET_EMPLOYER_CASTINGS = '/castingsByCreatorId';

export const CHANGE_SUBSCRIBE_STATUS = '/changeSubscribeStatus';

export const GET_CASTINGS_COMPNAY = '/castingsByCompanyId';

export const GET_DECLINED_COMPANIES = '/declinedCompanies';

export const GET_DECLINED_CASTINGS = '/declinedCastings';

export const CASTINGS = '/castings';

export const ADD_CASTING_TO_ARCHIVE = '/addCastingToArchive';

export const RESUME_CASTING_FROM_ARCHIVE = '/resumeCastingFromArchive';
